import { StatusTypes } from '@dataTypes/claimFeature.types'

export const getTrackingCheckStatus = (txn: any): StatusTypes => {
  if (txn.pending) {
    if (txn.plaid_account_id) {
      return StatusTypes.Processing
    } else {
      return StatusTypes.Pending
    }
  } else {
    if (txn.posted_date) {
      return StatusTypes.Posted
    } else {
      return StatusTypes.Deposited
    }
  }
}

export const getTrackingReferenceValues = (): any => {
  return {
    user_id: JSON.parse(localStorage.getItem('user') || '{}')?.user_id || '',
    clinic_id: localStorage.getItem('clinic_id') || '',
    db_name: localStorage.getItem('db_name') || '',
  }
}
